/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, ElementRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputAccessor} from '../input-accessor';

@Component({
    selector: 'ui-checkbox',
    template: require('./ui-checkbox.html'),
    styles: [require('./ui-checkbox.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: UiCheckbox, multi: true}
    ],
})



export class UiCheckbox extends InputAccessor {

    constructor(public elementRef: ElementRef) {
        super();
    }

    public prepareValueHook() {}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-checkbox/ui-checkbox.ts